import { render, staticRenderFns } from "./ClassFakList.vue?vue&type=template&id=b2cbdc7e&scoped=true&"
import script from "./ClassFakList.vue?vue&type=script&lang=js&"
export * from "./ClassFakList.vue?vue&type=script&lang=js&"
import style0 from "./ClassFakList.vue?vue&type=style&index=0&id=b2cbdc7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cbdc7e",
  null
  
)

export default component.exports